import { ArrowLeft } from 'lucide-react';
import { Logo } from '../Logo';
import { Footer } from '../Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white">
      <nav className="sticky top-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <a href="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Back to Home</a>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-6 md:px-8 py-20">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit mb-2">Privacy Policy</h1>
        <p className="text-sm text-zinc-500 mb-12">Last updated: March 28, 2026</p>

        <div className="prose-custom space-y-8">
          <Section title="1. Introduction">
            D3 Global Holdings LLC ("D3 Command," "we," "us," or "our") respects your privacy. This Privacy Policy describes how we collect, use, and protect your personal information when you use our AI-powered operational governance platform and related services.
          </Section>
          <Section title="2. Information We Collect">
            <strong>Account Information:</strong> Name, email address, company name, and role when you create an account or request a demo.<br /><br />
            <strong>Usage Data:</strong> Meeting recordings (when you upload them), tasks, risks, decisions extracted by our AI, dashboard interactions, and analytics data.<br /><br />
            <strong>Technical Data:</strong> IP address, browser type, device information, and access logs for security and performance monitoring.
          </Section>
          <Section title="3. How We Use Your Information">
            We use your information to: provide and maintain the D3 Command platform; process meeting recordings with AI to extract actionable insights; send transactional emails (task assignments, risk alerts, reports); improve our services and develop new features; comply with legal obligations; and prevent fraud and abuse.
          </Section>
          <Section title="4. Data Sharing">
            We do not sell your personal information. We may share data with: service providers who assist in delivering our platform (e.g., cloud hosting, email delivery via SendGrid); CRM systems (e.g., HubSpot) for lead management; and law enforcement when required by law. All service providers are bound by data processing agreements.
          </Section>
          <Section title="5. Data Security">
            We implement industry-standard security measures including: encryption in transit (TLS) and at rest; role-based access control (RBAC); multi-tenant data isolation; audit logging of all sensitive actions; and regular security reviews.
          </Section>
          <Section title="6. Data Retention">
            We retain your data for as long as your account is active. Meeting recordings are processed and can be deleted at your request. You may request deletion of your account and all associated data by contacting us.
          </Section>
          <Section title="7. Your Rights">
            Depending on your jurisdiction, you may have the right to: access your personal data; correct inaccurate data; request deletion of your data; export your data; and opt out of marketing communications. To exercise these rights, contact us at support@d3command.com.
          </Section>
          <Section title="8. Cookies">
            We use essential cookies for authentication and session management. We do not use advertising cookies. See our <a href="/cookie-policy" className="text-indigo-400 hover:text-indigo-300">Cookie Policy</a> for details.
          </Section>
          <Section title="9. Contact Us">
            If you have questions about this Privacy Policy, contact us at:<br /><br />
            D3 Global Holdings LLC<br />
            2807 Allen St #2164, Dallas, TX 75204<br />
            Email: <a href="mailto:support@d3command.com" className="text-indigo-400 hover:text-indigo-300">support@d3command.com</a><br />
            Phone: (888) 869-6184
          </Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
      <p className="text-sm text-zinc-400 leading-relaxed">{children}</p>
    </div>
  );
}
